import { render } from "./organisation-list.vue?vue&type=template&id=6cd96608"
import script from "./organisation-list.vue?vue&type=script&lang=js"
export * from "./organisation-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__